import { Model } from '../model';
import { IGalitem } from './galitem.interface';

export class Gal extends Model {
    public id: number;
    public name: string;
    public items: IGalitem[];
}
